(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a', ['app.plugins', 'app.data'])
    .config(config);
    
  
  config.$inject = ['pluginsProvider', 'PLUGIN'];
  
  function config(pluginsProvider, PLUGIN) {
    
    pluginsProvider.register(PLUGIN.POLL_TYPE, 'q-and-a', {icon: 'question_answer'});
    pluginsProvider.register(PLUGIN.RESULT_TYPE, 'q-and-a', true);
    pluginsProvider.register(PLUGIN.RESULT_EXPORTERS, 'q-and-a', {
      weight: -1,
      formats: [
        {
          name: 'Questions',
          extension: '.csv',
          factory: 'qAndAResultExportCsv'
        }
      ]
    });
  }
  
})();